import React, {useContext, useEffect} from 'react'
import Trombinoscope from 'components/trombinoscope/trombinoscope'
import headbandContext from 'contexts/headband'
import personnes from 'constants/personnes'
export default function TrombiFormation() {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "trombinoscope de l'équipe",
            icon : "picto_trombinoscope.svg",
            color : "bckDarkBlue"
        })
    }, [])
    return ( 
        <div id="trombiFormation"  className='page'>
            <Trombinoscope personnes={personnes} />
        </div>
    )
}
